module.exports = __webpack_public_path__ + "static/img/4520_phase_function_Paper_Points.4667ff8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4520_phase_function_Paper_Points.png
// module id = XtZx
// module chunks = 0